import { useSelector } from 'react-redux';
import { getProjectByIdState } from '../../../apps/main/rootReducer';
import { exportToCsv } from '../../../util/export';
import { ProjectByIdState } from '../../projects/reducers/projects';
import { TimeRecordSearchResultItem } from '../../../models/TimeRecord';
import useContactsContext from '../../contacts/hooks/useContactsProvider';
import { Contact } from '../../../models/Contact';
import i18n from '../../../i18n';
import moment from 'moment';

export const exportTimeRecordsToCsv: (
  timeRecords: TimeRecordSearchResultItem[],
  projectsById: ProjectByIdState,
  getContactById: (contactId: string) => Contact | null
) => void = (timeRecords, projectsById, getContactById) => {
  const dataRows: string[][] = timeRecords.map((timeRecord) => {
    if (timeRecord) {
      const project = timeRecord.data.projectId
        ? projectsById[timeRecord.data.projectId]
        : null;
      const contact = timeRecord.data.contactId
        ? getContactById(timeRecord.data.contactId)
        : null;
      return [
        moment(timeRecord.data.day).format('DD.MM.YYYY'),
        `${project?.number} ${project?.name}`,
        timeRecord.data.title,
        `${timeRecord.calculated.hours?.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`,
        `${timeRecord.data.kilometerDistance?.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`,
        timeRecord.calculated.projectPhase,
        `${contact?.firstName} ${contact?.lastName}`,
        timeRecord.data.invoiceNumber,
        timeRecord.data.description,
      ];
    }
    return [];
  });

  const headers = [
    i18n.t('timeRecords:table.columnTitle.day'),
    i18n.t('timeRecords:table.columnTitle.projectName'),
    i18n.t('timeRecords:table.columnTitle.title'),
    `${i18n.t('timeRecords:table.columnTitle.duration')} (h)`,
    `${i18n.t('timeRecords:table.columnTitle.kilometerDistance')} (km)`,
    i18n.t('timeRecords:table.columnTitle.projectPhase'),
    i18n.t('timeRecords:table.columnTitle.contactName'),
    i18n.t('timeRecords:table.columnTitle.invoiceNumber'),
    i18n.t('timeRecords:table.columnTitle.description'),
  ];
  exportToCsv(headers, dataRows, `${i18n.t('timeRecords:timeRecords')}.csv`);
};

export function useExportTimeRecordsToCsv(): (
  timeRecords: TimeRecordSearchResultItem[]
) => void {
  const projectsById = useSelector(getProjectByIdState);

  const { getContactById } = useContactsContext();

  return (timeRecords: TimeRecordSearchResultItem[]) =>
    exportTimeRecordsToCsv(timeRecords, projectsById, getContactById);
}
